// import analytics from '@utils/analytics';
import api from '@utils/api';
import { SM } from '@utils/imageutils';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ShippingLimitations from '@components/checkout/ShippingLimitations';
import customEventBus from '@common/scripts/libs/eventBus';
import ColorAndSize from '@common/components/aftercare/ColorAndSize';
import IconButton from '@stone/ui/button/IconButton';
import ProductImage from '@stone/components/product/ProductImage';
import BagItemPreorderinfo from '@stone/components/bag/BagItemPreorderinfo';
import ProductPrice from '@stone/components/product/ProductPrice';
import PriceDisplay from '@stone/components/product/PriceDisplay';
import Icon from '@stone/ui/icon/Icon';
import analytics from '@stone/utils/analytics';
const MiniBagItem = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { t } = useTranslation();
    // STETES ----
    const [showDeliveryLimitations, setShowDeliveryLimitations] = useState(false);
    // MEMO ----
    const inMinibag = useMemo(() => {
        return !props.inOrderSummary && !props.inOrderConfirm && !props.inExpressCheckout;
    }, [props.inOrderSummary, props.inOrderConfirm, props.inExpressCheckout]);
    //CALLBACK ---
    const removeFromBag = useCallback(() => {
        api.removeFromBag(props.item.id, props.item.lineUUID).then(() => {
            analytics.removeFromBag(props.item, props.item.quantity);
            props.onRemove();
        });
    }, [props.item]);
    const moveToWishlist = useCallback(() => {
        var _a, _b, _c;
        if (window.loggedin || !((_a = props.item) === null || _a === void 0 ? void 0 : _a.isMbm)) {
            api.addToWishlist(props.item.id, (_c = (_b = props.item) === null || _b === void 0 ? void 0 : _b.mbm) === null || _c === void 0 ? void 0 : _c.recipeId).then((data) => {
                customEventBus.emit('account:update', { wishlistIds: data.items });
                customEventBus.emit('wishlist:update', { wishlistIds: data.items });
                (props === null || props === void 0 ? void 0 : props.updateWishlist) && props.updateWishlist(data.items.length);
                analytics.addToWishlist(props.item.analyticsAttributes.item_MFC, 'minibag');
            });
            api.removeFromBag(props.item.id, props.item.lineUUID).then(() => {
                analytics.removeFromBag(props.item, props.item.quantity);
                props.onRemove();
            });
        }
        else {
            props.showLoginModal();
        }
    }, [props.item]);
    //METHODS ---
    const quantityDispay = () => {
        var _a, _b;
        return ((((_b = (_a = props.item) === null || _a === void 0 ? void 0 : _a.availability) === null || _b === void 0 ? void 0 : _b.isOutOfStock) && (React.createElement("p", { className: "minibag__product__label--outofstock" },
            React.createElement(Icon, { name: "alert", family: '10' }),
            " ",
            t('product.notavailable')))) || (React.createElement("p", { className: "option-product__quantity" },
            React.createElement("span", { className: "option-product__label" },
                t('bag.qty'),
                ":"),
            " ",
            props.item.quantity)));
    };
    return (React.createElement("li", { className: "minibag__productcontainer" },
        React.createElement("div", { className: "minibag__product", "data-bagid": props.item.id, tabIndex: -1 },
            React.createElement("div", { className: "minibag__product__image", "aria-hidden": "true" },
                React.createElement(ProductImage, { img: props.item.imgs, sizes: [SM], type: "F", tiletype: ((_a = props.item) === null || _a === void 0 ? void 0 : _a.isMbm) ? 'mbm' : '' })),
            React.createElement("div", { className: "minibag__product__content" },
                React.createElement("div", { className: "minibag__product__columns" },
                    React.createElement("div", { className: "minibag__product__title" },
                        React.createElement("p", { className: "font__title" }, props.item.productName),
                        props.item.seoName && React.createElement("p", { className: "font__labelling" }, props.item.seoName)),
                    React.createElement("p", { className: "minibag__product__price" }, ((_b = props.item) === null || _b === void 0 ? void 0 : _b.price) ? (
                    /* CART/MINICART ITEM */
                    React.createElement(React.Fragment, null,
                        React.createElement(ProductPrice, { isExchangePrice: props.isExchangeItem, price: (_c = props.item) === null || _c === void 0 ? void 0 : _c.price, promotions: (_d = props.item) === null || _d === void 0 ? void 0 : _d.appliedPromotions }),
                        !props.isExchangeItem && ((_f = (_e = props.item) === null || _e === void 0 ? void 0 : _e.availability) === null || _f === void 0 ? void 0 : _f.preorder) && React.createElement("span", { className: "minibag__product__label--preorder" }, t('button.preorder')))) : (
                    /* ORDER ITEM */
                    React.createElement(PriceDisplay, { isExchangePrice: props.isExchangeItem, list: (_g = props.item) === null || _g === void 0 ? void 0 : _g.singleItemPrice, sales: (_h = props.item) === null || _h === void 0 ? void 0 : _h.singleItemAdjustedPrice, promotions: (_j = props.item) === null || _j === void 0 ? void 0 : _j.appliedPromotions })))),
                React.createElement("div", { className: "minibag__product__info" },
                    (!!props.inOrderSummary || !!props.inOrderConfirm) && quantityDispay(),
                    ((_k = props.item) === null || _k === void 0 ? void 0 : _k.isParfum) ? (React.createElement("p", { className: "option-product__size" },
                        t('label.format'),
                        " ", (_m = (_l = props.item) === null || _l === void 0 ? void 0 : _l.parfumAttributes.productFamily.find((el) => el.id == props.item.id)) === null || _m === void 0 ? void 0 :
                        _m.format)) : (React.createElement(ColorAndSize, { invertElements: true, item: props.item }))),
                !props.inOrderSummary && !props.inOrderConfirm && (React.createElement("div", { className: "minibag__product__bottom" },
                    quantityDispay(),
                    React.createElement("div", { className: "minibag__product__actions" },
                        React.createElement(IconButton, { type: "button", icon: "remove", ariaLabel: t('button.remove'), className: "hideborder issmall", onClick: removeFromBag }),
                        !((_o = props.item) === null || _o === void 0 ? void 0 : _o.signupSaleProduct) && (React.createElement(IconButton, { type: "button", icon: "save", ariaLabel: t('button.saveforlater'), className: "hideborder issmall", onClick: moveToWishlist }))))))),
        props.item.isParfum && (React.createElement("div", { className: "col-12 minibag__product__no_refundable" }, (props === null || props === void 0 ? void 0 : props.hazardNotShippable) ? (React.createElement(React.Fragment, null,
            React.createElement("span", { dangerouslySetInnerHTML: { __html: t('checkout.shipping.deliveyhazarditem') } }),
            ' ',
            React.createElement("button", { type: "button", onClick: () => {
                    setShowDeliveryLimitations(true);
                }, dangerouslySetInnerHTML: { __html: t('checkout.shipping.discoverdeliveyhazard') } }),
            React.createElement(ShippingLimitations, { open: showDeliveryLimitations, onRequestClose: () => setShowDeliveryLimitations(false) }))) : (React.createElement("p", { className: "primary-xs" }, window.isClothing ? t('returns.itemnotreturnableparfumclothing') : t('returns.itemnotreturnableparfum'))))),
        ((_p = props.item.availability) === null || _p === void 0 ? void 0 : _p.preorder) && inMinibag && React.createElement(BagItemPreorderinfo, { item: props.item })));
};
export default MiniBagItem;
